import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Gift, Sparkles, Store, ArrowRight, CheckCircle2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useLocale, PRICING } from '@/contexts/LocaleContext';

const LaunchPromoBanner = ({ variant = 'full', className = '' }) => {
  const navigate = useNavigate();
  const { isUSA, currency } = useLocale();
  const region = isUSA ? 'US' : 'MX';
  const pricing = PRICING[region].pro;

  // Compact version for registration page
  if (variant === 'compact') {
    return (
      <div className={`bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-xl p-4 text-white ${className}`}>
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
            <Store className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-lg">
              {isUSA ? 'Start for FREE' : '¡Empieza GRATIS!'}
            </p>
            <p className="text-sm text-white/90">
              {isUSA 
                ? 'Create your catalog today. No credit card required.'
                : 'Crea tu catálogo hoy. Sin tarjeta de crédito.'
              }
            </p>
            <p className="text-xs text-emerald-100 mt-1 flex items-center gap-1">
              <CheckCircle2 className="w-3 h-3" />
              {isUSA 
                ? `Upgrade to PRO: $${pricing.price} ${currency}/month`
                : `Mejora a PRO: $${pricing.price} ${currency}/mes`}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Full banner for landing page
  return (
    <div className={`bg-gradient-to-r from-emerald-500 to-emerald-600 ${className}`}>
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex w-12 h-12 bg-white/20 rounded-full items-center justify-center">
              <Sparkles className="w-6 h-6 text-white" />
            </div>
            <div className="text-white text-center md:text-left">
              <p className="font-bold text-lg flex items-center gap-2 justify-center md:justify-start">
                <Gift className="w-5 h-5" />
                {isUSA ? 'Start FREE Today!' : '¡Empieza GRATIS Hoy!'}
              </p>
              <p className="text-white/90 text-sm">
                {isUSA 
                  ? 'Create your catalog and start receiving clients'
                  : 'Crea tu catálogo y empieza a recibir clientes'
                }
              </p>
              <p className="text-white/80 text-xs mt-1 flex items-center gap-1 justify-center md:justify-start">
                <CheckCircle2 className="w-3 h-3" />
                {isUSA 
                  ? 'No credit card required. Upgrade anytime.'
                  : 'Sin tarjeta de crédito. Mejora cuando quieras.'}
              </p>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="text-center px-4 py-2 bg-white/20 rounded-lg">
              <p className="text-2xl font-bold text-white">5</p>
              <p className="text-xs text-white/80 uppercase tracking-wide">
                {isUSA ? 'free products' : 'productos gratis'}
              </p>
            </div>
            
            <Button 
              onClick={() => navigate('/register')}
              className="bg-white text-emerald-600 hover:bg-white/90 font-bold"
            >
              {isUSA ? 'Start free' : 'Empieza gratis'}
              <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LaunchPromoBanner;
